// Extracting value after the last '/' from a given string.
export const getCode = (value: string) => {
  return value.substring(value.lastIndexOf('/') + 1)
}
